export default __webpack_public_path__ + "static/media/pvilla3-1.bb71e1ba.webp";